import { useCallback } from 'react';

import WfCheckbox from './WfCheckbox';

interface CheckboxGroupOptionType {
  label: string;
  value: string;
}

export interface WfCheckboxGroupProps {
  value: string[];
  options: Array<string | CheckboxGroupOptionType>;
  onChange: (value: string[]) => void;
}

function WfCheckboxGroup(props: WfCheckboxGroupProps) {
  const { value, options, onChange } = props;

  const handleChange = useCallback(
    (key: string, checked: boolean) => {
      const temp = [...value];
      if (checked) {
        temp.push(key);
      } else {
        temp.splice(temp.indexOf(key), 1);
      }

      onChange(temp);
    },
    [onChange, value],
  );

  return (
    <div className="wf-checkbox-group-container">
      {options.map((option) => {
        if (typeof option === 'string') {
          return (
            <WfCheckbox
              key={option}
              checked={value.includes(option)}
              onChange={(checked) => handleChange(option, checked)}
            />
          );
        } else {
          return (
            <WfCheckbox
              key={option.value}
              label={option.label}
              checked={value.includes(option.value)}
              onChange={(checked) => handleChange(option.value, checked)}
            />
          );
        }
      })}
    </div>
  );
}

export default WfCheckboxGroup;
